import { format } from 'date-fns'
import { DaySlotProfessionalSchedule } from '.'
import { DataFormatted } from '@/modules/Telemedicine/store/ScheduleAppointment/ScheduleAppointment.types'
import { getUTCDate } from '@/modules/Telemedicine/utils/getUTCDate/getUTCDate'

export class ProfessionalScheduleMapper {
  static toDomain(data: DaySlotProfessionalSchedule) {
    return {
      date: getUTCDate(data?.date),
      slots: data?.schedules?.map(slot => {
        return {
          id: slot?.id,
          time: slot?.time,
        }
      }),
    }
  }
}

export class ProfessionalFilterMapper {
  static toPersistence(data: DataFormatted) {
    const isPsychologist = data.professionalTypeKey === 'PSICOLOGO'
    return {
      clinicId: data.clinicId,
      ageGroup: data.ageRange,
      professionalName: data.professionalName,
      professionalType: data.professionalTypeKey,
      ...(data?.professional?.key && { professionalId: data.professional.key }),
      ...(data?.specialtyId &&
        !isPsychologist && { specialtyId: data.specialtyId }),
      availabilityStartDate: data.startDate
        ? format(new Date(data?.startDate), 'yyyy-MM-dd')
        : null,
      noScheduleAvailable: data.noScheduleAvailable,
    }
  }
}
